import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SummaryDetailsHeader, SummaryDetailsRow } from './summary-details.models';

/**
 * Presentation-only summary card matching the Order Summary tab layout.
 * Consumers supply section title, optional header block, and label/value rows.
 */
@Component({
  selector: 'app-summary-details',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './summary-details.component.html',
  styleUrls: ['./summary-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SummaryDetailsComponent {
  @Input() title = '';
  @Input() header: SummaryDetailsHeader | null = null;
  @Input() rows: SummaryDetailsRow[] = [];
}
